import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import MyBadges from "./MyBadges";
import MyCertificates from "./MyCertificates";
import SideNav from "./SideNav";
import SideNavDetail from "./SideNavDetail";
import { scroller } from "react-scroll";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { learningPoints } from "../../redux/Cart/actions";
import Loader from "../../components/Loader/Loader";
import StaticUtils from "../../utils/StaticUtils";
import { leaderBoardData, leaderBoardDataTest } from "../../utils/testJson";
import ReactRoundedImage from "react-rounded-image";
import "./MenuDetailComponent.scss";
import {
  getLeaderBoardReq,
  getUserPointsReq,
  onUploadReqBroker,
  setCreditPointBalance,
  updateCoverPhoto,
  userDetailBroker,
} from "../../redux/user/actions";
import { SessionKeys } from "../../utils/AppUtils";
import moment from "moment";
import NotFoundImage from "../NewDesign/NotFound/NotFoundImage";
import { getActiveHeader } from "../../redux/home/actions";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import { loginResponse } from "../../redux/auth/actions";
import { FormGroup, Input } from "reactstrap";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import { Spinner, Overlay, Popover } from "react-bootstrap";
import ProfileDetailComponent from "./ProfileDetailComponent";
import EventDetailComponent from "./EventDetailComponent";
import OBLPDetailComponent from "./OBLPDetailComponent";
import CoachingNotesListComp from "./CoachingNotesListComp";
import ConfirmModal from "../modal/ConfirmModal";
import SimplePopup from "../modal/SimplePopup";
import { useTranslation } from "react-i18next";
import BuyCreditPoints from "../../components/profile/BuyCreditPoints";
import "../../components/profile/UserProfile.scss";
import { countryDatas } from "../../utils/StaticData";
import MsgModal from "../modal/MsgModal";

const MenuDetailComponent = () => {
  const [coachData, setCoachData] = useState();
  const [loader, setLoader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [coachId, setCoachId] = useState("");

  const [isLock, setIsLock] = useState(false);
  const [confirmMsgModal, setConfirmMsgModal] = useState(false);
  const [showModalMsg1, setShowModalMsg1] = useState(
    "This content is not available in your current subscription, please contact to Halifax Sales AI support team."
  );

  const userDetailBrokerResponse = useSelector(
    (state) => state.user.userBroker
  );
  useEffect(() => {
    setLoader(true);
    profileAPICall();
  }, [localStorage.getItem(SessionKeys.API_TOKEN_BROKER)]);

  const profileAPICall = () => {
    dispatch(
      userDetailBroker({
        module: "getOrderDetailBroker",
        apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
        userId: authBroker?.payload?.user?.user_id,
      })
    );
  };

  useEffect(() => {
    if (!_.isEmpty(userDetailBrokerResponse)) {
      if (userDetailBrokerResponse?.status === "success") {
        const listData = userDetailBrokerResponse;

        setCoachData(listData?.payload?.payload);
        setCoachId(listData?.payload?.payload?.coach_info?.user_id);
        console.log("listdate", coachData?.profile_img);
        setLoader(false);
        console.log("userListData", userDetailBrokerResponse);
        if (
          !_.isEmpty(userDetailBrokerResponse?.payload?.payload?.credit_product)
        ) {
          const creditPoint =
            userDetailBrokerResponse?.payload?.payload?.credit_product;
          dispatch(setCreditPointBalance(creditPoint?.pending_balance));
        }
      }
    }
  }, [userDetailBrokerResponse]);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const section = params.get("section");
  const user_id = params.get("user_id");
  const isOther = "0"; //localStorage.getItem(SessionKeys.USER_ID) === user_id ? "0" : "1";

  const userDetailRes = useSelector((state) => state.user.userBroker);
  var userDetailResForOther = useSelector(
    (state) => state.user.userBrokerForOther
  );
  var uploadRes = useSelector((state) => state.user.uploadRes);
  const userRole = useSelector((state) => state.user.role);
  const authBroker = useSelector((state) => state.auth.authBroker);
  const leaderBoardDataTestRes = useSelector((state) => state.user.leaderBoard);
  const userPointsRes = useSelector((state) => state.user.userPoints);
  const userCreditBalance = useSelector(
    (state) => state.user.userCreditBalance
  );
  const [totalLearningPoints, setTotalLearningPoints] = useState(0);
  const myLearningPointsRes = useSelector(
    (state) => state.carts?.learningPoints
  );
  const [isLoading, setIsLoading] = useState(true);

  const [leaderBoardData, setLeaderBoardData] = useState([]);
  const [lastUpdateTime, setLastUpdateTime] = useState("");
  const [coursePoints, setCoursePoints] = useState(0);
  const [videoPoints, setVideoPoints] = useState(0);
  const [rolePlayPoints, setRolePlayPoints] = useState(0);

  const [key, setKey] = useState("");
  const [userDetailState, setUserDetailState] = useState({});

  const handleFileUploadClick = () => {
    document.getElementById("exampleFileCover").click();
  };

  const [confirmModal, setConfirmModal] = useState(false);
  const [showModalMsg, setShowModalMsg] = useState("");
  const [isConfirm, setIsConfirm] = useState();

  // console.log("Sectionnnnns", isOther);

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [showLimitPopup, setShowLimitPopup] = useState(false);
  const fileInputRef = useRef(null);
  const ref = useRef(null);

  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [country, setCountry] = useState("");

  useEffect(() => {
    let userDetail = isOther === "1" ? userDetailResForOther : userDetailRes;
    if (!_.isEmpty(userDetail)) {
      let role = userDetail?.payload?.payload?.roles;
      if (role?.includes("realtor")) {
        setRole("End user");
      } else if (role?.includes("manager")) {
        setRole("Team Manager");
      } else if (role?.includes("instructor")) {
        setRole("External Coach");
      } else if (role?.includes("host")) {
        setRole("host");
      } else if (role?.includes("broker_admin")) {
        setRole("admin");
      }
      if (role?.includes("participant")) {
        setRole("End user");
      }
    }
  }, [userDetailRes, userDetailResForOther]);

  useEffect(() => {
    let userDetail = isOther === "1" ? userDetailResForOther : userDetailRes;
    if (!_.isEmpty(userDetail)) {
      console.log("details---", userDetail?.payload?.payload);
      setUserDetailState(userDetail?.payload?.payload);
    }
  }, [userDetailRes, userDetailResForOther]);

  useEffect(() => {
    let userDetail = isOther === "1" ? userDetailResForOther : userDetailRes;
    if (!_.isEmpty(userDetail)) {
      setName(
        `${userDetail?.payload?.payload?.firstname}` +
          " " +
          `${userDetail?.payload?.payload?.lastname}`
      );
      countryDatas.map((countryData) => {
        if (countryData.id === userDetail?.payload?.payload?.country) {
          setCountry(countryData.name);
        }
      });
    }
  }, [userDetailRes, userDetailResForOther]);

  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  const removeCover = () => {
    onCoverPhotoUpload("", true);
  };

  const handleFileChange = (e) => {
    if (e.target.files[0] !== undefined && e.target.files[0] !== null) {
      // Handle the file upload logic here
      let file = e.target.files[0];

      if (file.size > 1048576) {
        // 1 MB in bytes
        setShowLimitPopup(true);
        e.target.value = ""; // clear the file input
        file = "";
      } else {
        onCoverPhotoUpload(e.target.files[0], false);
      }
    }
  };

  const [isCoverLoading, setisCoverLoading] = useState(true);
  const onCoverPhotoUpload = (value, isDelete) => {
    setShow(false);
    setIsLoading(true);
    const formData = new FormData();
    formData.append(
      "token",
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
    );
    formData.append("cover", isDelete ? "" : value);
    dispatch(updateCoverPhoto(formData));
  };

  var coverPhotoRes = useSelector((state) => state.user.coverPhoto);

  useEffect(() => {
    console.log("cover---", coverPhotoRes);
    if (coverPhotoRes?.status === "success") {
      authBroker.payload.user.user_cover_image = coverPhotoRes?.cover_url;
      dispatch(loginResponse(authBroker));
      dispatch(
        userDetailBroker({
          module: "getOrderDetailBroker",
          apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          userId: authBroker?.payload?.user?.user_id,
        })
      );
      setConfirmModal(true);
      setIsConfirm(false);
      setShowModalMsg(coverPhotoRes?.message);
      // alert(coverPhotoRes?.message);
      coverPhotoRes.status = "";
      // dispatch(updateCoverPhotoResponseClear());
    } else if (coverPhotoRes?.status === "error") {
      setConfirmModal(true);
      setIsConfirm(false);
      setShowModalMsg("Failed in updating cover image");
    }
    setIsLoading(false);
  }, [coverPhotoRes]);

  const classNameArr = [
    "points-one",
    "points-two",
    "points-theree",
    "points-four",
  ];

  useEffect(() => {
    dispatch(getActiveHeader(""));
    window.scrollTo(0, 0);
    // getLeaderBoardData();
    // getUserPoints();
  }, []);

  useEffect(() => {
    // console.log('leaderBoardDataTestRes: ',leaderBoardDataTestRes);
    if (!_.isEmpty(leaderBoardDataTestRes)) {
      if (leaderBoardDataTestRes?.status === "success") {
        // console.log('filteredArrayFromComponent1', StaticUtils.getLeaderBoardData(leaderBoardDataTestRes?.payload?.payload));
        setLeaderBoardData(
          leaderBoardDataTestRes?.payload?.payload?.list?.reverse()
        );
        setLastUpdateTime(
          moment
            .unix(leaderBoardDataTestRes?.payload?.payload?.last_updated)
            .format("Do MMMM YYYY, h:mm A")
        );
      }
    }
  }, [leaderBoardDataTestRes]);

  //get leader board
  // const getLeaderBoardData = () => {
  //   dispatch(
  //     getLeaderBoardReq({
  //       module: "leaderBoard",
  //       postData: {
  //         token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),

  //         user_id:
  //           isOther === "1"
  //             ? user_id
  //             : localStorage.getItem(SessionKeys.USER_ID),
  //       },
  //     })
  //   );
  // };

  useEffect(() => {
    if (!_.isEmpty(userPointsRes)) {
      if (userPointsRes?.status === "success") {
        // console.log("userPointsRes:", userPointsRes);
        // setLeaderBoardData(userPointsRes)
        setCoursePoints(
          userPointsRes?.payload?.payload?.course_lp !== null
            ? userPointsRes?.payload?.payload?.course_lp
            : 0
        );
        setVideoPoints(
          userPointsRes?.payload?.payload?.video_lp !== null
            ? userPointsRes?.payload?.payload?.video_lp
            : 0
        );
        setRolePlayPoints(
          userPointsRes?.payload?.payload?.role_play_lp !== null
            ? userPointsRes?.payload?.payload?.role_play_lp
            : 0
        );
        // let totalPoints =
        //   userPointsRes?.payload?.payload?.course_lp !== null
        //     ? Number(userPointsRes?.payload?.payload?.course_lp)
        //     : 0 + userPointsRes?.payload?.payload?.video_lp !== null
        //     ? Number(userPointsRes?.payload?.payload?.video_lp)
        //     : 0 + userPointsRes?.payload?.payload?.role_play_lp !== null
        //     ? Number(userPointsRes?.payload?.payload?.role_play_lp)
        //     : 0;

        let totalPoints =
          Number(userPointsRes?.payload?.payload?.course_lp) +
          Number(userPointsRes?.payload?.payload?.video_lp) +
          Number(userPointsRes?.payload?.payload?.role_play_lp);

        setTotalLearningPoints(totalPoints);
      }
    }
  }, [userPointsRes]);

  // const getUserPoints = () => {
  //   dispatch(
  //     getUserPointsReq({
  //       module: "userPoints",
  //       postData: {
  //         token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
  //         user_id:
  //           isOther === "1"
  //             ? user_id
  //             : localStorage.getItem(SessionKeys.USER_ID),
  //       },
  //     })
  //   );
  // };

  useEffect(() => {
    if (!_.isEmpty(authBroker)) {
      setIsLock([3].includes(authBroker?.payload?.user?.access_type));
    }
  }, [dispatch, authBroker]);

  useEffect(() => {
    // console.log("learningpoint", myLearningPointsRes);

    if (myLearningPointsRes?.status === "success") {
      var lpArray = myLearningPointsRes?.payload;

      let totalPoint = 0;
      if (!_.isEmpty(lpArray)) {
        if (_.isArray(lpArray) && lpArray.length > 0) {
          totalPoint = 0;
          for (let learningPoint of lpArray) {
            totalPoint = totalPoint + _.toNumber(learningPoint.point);
          }
        }
        myLearningPointsRes.payload = lpArray;
        // setTotalLearningPoints(totalPoint);
      }
    }
  }, [myLearningPointsRes]);

  useEffect(() => {
    switch (section) {
      case "dashboard":
        scroller.scrollTo("dashboardId", {
          duration: 50,
          delay: 0,
          smooth: "easeInOutQuart",
        });
        break;
      case "certificate":
        scroller.scrollTo("certificate", {
          duration: 50,
          delay: 0,
          smooth: "easeInOutQuart",
        });
        break;
      case "badge":
        scroller.scrollTo("badge", {
          duration: 50,
          delay: 0,
          smooth: "easeInOutQuart",
        });
        break;
      default: {
        scroller.scrollTo("editProfileId", {
          duration: 50,
          delay: 0,
          smooth: "easeInOutQuart",
        });
      }
    }
  }, [section]);

  const [isProfileLoading, setIsProfileLoading] = useState(true);
  const onUpload = (value, isDelete) => {
    console.log("value", value);
    setIsProfileLoading(true);
    const formData = new FormData();
    formData.append(
      "token",
      localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
    );
    formData.append("avatar", isDelete ? "" : value);
    dispatch(onUploadReqBroker(formData));
  };

  useEffect(() => {
    if (uploadRes?.status === "success") {
      authBroker.payload.user.profile_img = uploadRes.profile_img;
      dispatch(loginResponse(authBroker));
      dispatch(
        userDetailBroker({
          module: "getOrderDetailBroker",
          apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          userId: authBroker?.payload?.user?.user_id,
        })
      );
      // alert(uploadRes?.message);
      setConfirmModal(true);
      setIsConfirm(false);
      setShowModalMsg(uploadRes?.message);
      uploadRes.status = "";
    } else {
    }
    setIsProfileLoading(false);
  }, [uploadRes]);

  var coverPhotoRes = useSelector((state) => state.user.coverPhoto);
  useEffect(() => {
    console.log("cover---", coverPhotoRes, authBroker);
    if (coverPhotoRes?.status === "success") {
      authBroker.payload.user.user_cover_image = coverPhotoRes?.cover_url;
      dispatch(loginResponse(authBroker));
      dispatch(
        userDetailBroker({
          module: "getOrderDetailBroker",
          apiToken: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          userId: authBroker?.payload?.user?.user_id,
        })
      );
      setConfirmModal(true);
      setIsConfirm(false);
      setShowModalMsg(coverPhotoRes?.message);
      // alert(coverPhotoRes?.message);
      coverPhotoRes.status = "";
      // dispatch(updateCoverPhotoResponseClear());
    } else if (coverPhotoRes?.status === "error") {
      setConfirmModal(true);
      setIsConfirm(false);
      setShowModalMsg("Failed in updating cover image");
    }
    setIsLoading(false);
  }, [coverPhotoRes]);

  const tab = params.get("tab");

  useEffect(() => {
    renderComp();
  }, [tab]);

  useEffect(() => {
    if (tab === "1") {
      setKey("personaldetail");
    } else if (tab === "2") {
      setKey("course");
    } else if (tab === "3") {
      setKey("videos");
    } else if (tab === "4") {
      setKey("events");
    } else if (tab === "5") {
      setKey("certifications");
    } else if (tab === "6") {
      setKey("certificates");
    } else if (tab === "7") {
      setKey("badges");
    } else if (tab === "8") {
      setKey("learningpath");
    } else if (tab === "9") {
      setKey("onboarding");
    } else if (tab === "10") {
      setKey("coachingnotes");
    }
  }, [tab]);

  const renderComp = () => {
    if (tab === "1") {
      return <SideNavDetail setIsLoading={setIsLoading} />;
    } else if (tab === "2") {
      return (
        <ProfileDetailComponent
          isVideos={false}
          asset_id={["5"]}
          userId={
            _.toNumber(isOther) !== "0"
              ? user_id
              : authBroker?.payload?.user?.user_id
          }
          setIsLoading={setIsLoading}
          isOther={isOther}
        />
      );
    } else if (tab === "3") {
      return (
        <ProfileDetailComponent
          isVideos={true}
          asset_id={["8"]}
          userId={
            _.toNumber(isOther) !== "0"
              ? user_id
              : authBroker?.payload?.user?.user_id
          }
          setIsLoading={setIsLoading}
          isOther={isOther}
        />
      );
    } else if (tab === "4") {
      return (
        <EventDetailComponent
          userId={
            _.toNumber(isOther) ? user_id : localStorage.getItem("USER_ID")
          }
          setIsLoading={setIsLoading}
          isEvent={true}
          isOther={isOther}
        />
      );
    } else if (tab === "5") {
      return (
        <EventDetailComponent
          userId={
            _.toNumber(isOther) ? user_id : localStorage.getItem("USER_ID")
          }
          setIsLoading={setIsLoading}
          isEvent={false}
          isOther={isOther}
        />
      );
    } else if (tab === "6") {
      return <MyCertificates isOther={isOther} setIsLoading={setIsLoading} />;
      return "tab6";
    } else if (tab === "7") {
      return <MyBadges isOther={isOther} setIsLoading={setIsLoading} />;
      return "tab7";
    } else if (tab === "8") {
      return (
        <OBLPDetailComponent
          isOB={0}
          userId={
            _.toNumber(isOther) !== "0"
              ? user_id
              : authBroker?.payload?.user?.user_id
          }
          setIsLoading={setIsLoading}
          isOther={isOther}
        />
      );
    } else if (tab === "9") {
      return (
        <OBLPDetailComponent
          isOB={1}
          userId={
            _.toNumber(isOther) ? user_id : localStorage.getItem("USER_ID")
          }
          setIsLoading={setIsLoading}
          isOther={isOther}
        />
      );
    } else if (tab === "10") {
      return <CoachingNotesListComp key={key} />;
    } else {
      return <SideNavDetail setIsLoading={setIsLoading} />;
    }
  };

  return (
    <>
      <Loader start={isLoading} />
      <section className="usrer-pfiled">
        <div
          className="banner-detail"
          style={{
            backgroundImage: `url(${
              userDetailState?.user_cover_image
                ? userDetailState?.user_cover_image
                : "/images/profile-bg.png"
            })`,
          }}
        ></div>
        <div className="coach-detail-header">
          <div className="container">
            <div className="row">
              <div className="d-flex gap-3 align-items-xl-start justify-content-between pf-sectio">
                <div className="profile-box-coach">
                  {isProfileLoading ? (
                    <ShimmerScreen
                      case={"circle"}
                      height={"12.125rem"}
                      width={"12.125rem"}
                    />
                  ) : (
                    <div className="prfile-obx">
                      <ReactRoundedImage
                        id="profileImg"
                        image={
                          userDetailState?.profile_img !== undefined &&
                          userDetailState?.profile_img !== ""
                            ? userDetailState?.profile_img
                            : "/images/avatar.svg"
                        }
                        roundedSize="0"
                        imageWidth="194"
                        imageHeight="194"
                      />
                      {isOther === "1" ? (
                        ""
                      ) : (
                        <div className="img-profile_visbty">
                          <FormGroup>
                            <svg
                              className="img-fluid profileICON"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              id="More"
                              width="30"
                              height="30"
                              viewBox="0 0 30 30"
                            >
                              <defs>
                                <linearGradient
                                  id="linear-gradient"
                                  y1="0.5"
                                  x2="1"
                                  y2="0.5"
                                  gradientUnits="objectBoundingBox"
                                >
                                  <stop offset="0" stopColor="#415385" />
                                  <stop offset="1" stopColor="#415385" />
                                </linearGradient>
                              </defs>
                              <circle
                                id="Ellipse_57"
                                data-name="Ellipse 57"
                                cx="15"
                                cy="15"
                                r="15"
                                fill="url(#linear-gradient)"
                              />
                              <circle
                                id="Ellipse_179"
                                data-name="Ellipse 179"
                                cx="13"
                                cy="13"
                                r="13"
                                transform="translate(2 2)"
                                fill="#fff"
                              />
                              <g
                                id="Group_2342"
                                data-name="Group 2342"
                                transform="translate(-775 -762)"
                              >
                                <circle
                                  id="Ellipse_183"
                                  data-name="Ellipse 183"
                                  cx="2"
                                  cy="2"
                                  r="2"
                                  transform="translate(782 775)"
                                  fill="#415385"
                                />
                                <circle
                                  id="Ellipse_184"
                                  data-name="Ellipse 184"
                                  cx="2"
                                  cy="2"
                                  r="2"
                                  transform="translate(788 775)"
                                  fill="#415385"
                                />
                                <circle
                                  id="Ellipse_185"
                                  data-name="Ellipse 185"
                                  cx="2"
                                  cy="2"
                                  r="2"
                                  transform="translate(794 775)"
                                  fill="#415385"
                                />
                              </g>
                            </svg>

                            <Input
                              type="file"
                              name="file"
                              accept="image/png,image/jpeg"
                              id="exampleFile"
                              innerRef={fileInputRef}
                              onChange={(e) => {
                                // console.log('Profile Image:', e.target.files[0]);
                                if (
                                  e.target.files[0] !== undefined &&
                                  e.target.files[0] !== null
                                )
                                  onUpload(e.target.files[0], false);
                                fileInputRef.current.value = null;
                              }}
                            />

                            {isProfileLoading ? (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                variant="primary"
                              />
                            ) : (
                              ""
                            )}
                          </FormGroup>
                          {userDetailState?.profile_img !== undefined &&
                          userDetailState?.profile_img !== "" ? (
                            <div
                              className="delete-iamge-pointer"
                              onClick={() => {
                                onUpload(null, true);
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 30 30"
                              >
                                <defs>
                                  <linearGradient
                                    id="linear-gradient"
                                    x2="1"
                                    y1="0.5"
                                    y2="0.5"
                                    gradientUnits="objectBoundingBox"
                                  >
                                    <stop offset="0" stopColor="#415385"></stop>
                                    <stop offset="1" stopColor="#415385"></stop>
                                  </linearGradient>
                                </defs>
                                <circle
                                  cx="15"
                                  cy="15"
                                  r="15"
                                  fill="url(#linear-gradient)"
                                  data-name="Ellipse 57"
                                ></circle>
                                <circle
                                  cx="13"
                                  cy="13"
                                  r="13"
                                  fill="#fff"
                                  data-name="Ellipse 179"
                                  transform="translate(2 2)"
                                ></circle>
                                <path
                                  fill="#415385"
                                  d="M10.582.784h-2.94l-.23-.458A.588.588 0 006.885 0h-2.8a.581.581 0 00-.524.326l-.23.458H.392A.392.392 0 000 1.176v.784a.392.392 0 00.392.392h10.19a.392.392 0 00.392-.392v-.784a.392.392 0 00-.392-.392zM1.3 11.439a1.176 1.176 0 001.173 1.1H8.5a1.176 1.176 0 001.173-1.1l.519-8.3H.784z"
                                  data-name="Icon awesome-trash"
                                  transform="translate(9.514 8.729)"
                                ></path>
                              </svg>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div className="prfoile-right">
                  <div className="btn-box-fr d-flex gap-3">
                    {/* <button class="btn-primary d-flex gap-2 align-items-center mt-4" onClick={() => navigate(
                      `/profile/edit?section=edit&tab=1&user_id=${authBroker?.payload?.user.user_id}`
                    )}
                    >
                      {t("Update Profile")}
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                        <path
                          d="M11.4875 0.913009C11.1519 0.588577 10.7033 0.407227 10.2365 0.407227C9.76971 0.407227 9.32116 0.588577 8.98552 0.913009L1.18552 8.71301L0.00952148 12.397L3.72352 11.197L11.4875 3.39701C11.8102 3.06166 11.9904 2.61438 11.9904 2.14901C11.9904 1.68364 11.8102 1.23636 11.4875 0.901009V0.913009ZM2.87152 10.339L2.06152 9.53501L8.79352 2.79701L9.60952 3.60701L2.87152 10.339Z"
                          fill="#415385" />
                      </svg>
                    </button> */}
                    {isOther === "0" ? (
                      <div className="btn-cover-img" ref={ref}>
                        <label id="exampleFile" for="exampleFile" className="">
                          <button
                            className="session-btn d-flex gap-2 align-items-center mt-4"
                            // disabled={isCoverLoading}
                            onClick={handleClick}
                          >
                            {" "}
                            {t("Edit Cover")}{" "}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width={24}
                              height={24}
                              fill="currentColor"
                            >
                              <path d="M3 19H21V21H3V19ZM13 5.82843V17H11V5.82843L4.92893 11.8995L3.51472 10.4853L12 2L20.4853 10.4853L19.0711 11.8995L13 5.82843Z"></path>
                            </svg>
                          </button>
                        </label>
                        <Overlay
                          show={show}
                          target={target}
                          placement="bottom"
                          container={ref.current}
                          containerPadding={20}
                        >
                          <Popover id="popover-contained">
                            <Popover.Body>
                              <FormGroup>
                                <input
                                  type="file"
                                  name="file"
                                  accept="image/png,image/jpeg"
                                  id="exampleFileCover"
                                  style={{ display: "none" }}
                                  onChange={handleFileChange}
                                />
                              </FormGroup>
                              <div className="d-flex gap-3 flex-column justify-content-between">
                                <button
                                  className="linkbtn"
                                  onClick={handleFileUploadClick}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width={24}
                                    height={24}
                                    fill="currentColor"
                                  >
                                    <path d="M3 19H21V21H3V19ZM13 5.82843V17H11V5.82843L4.92893 11.8995L3.51472 10.4853L12 2L20.4853 10.4853L19.0711 11.8995L13 5.82843Z"></path>
                                  </svg>{" "}
                                  {t("Upload Cover")}
                                </button>
                                {userDetailState?.user_cover_image ? (
                                  <button
                                    className="linkbtn"
                                    onClick={() => removeCover()}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      viewBox="0 0 24 24"
                                      width={24}
                                      height={24}
                                      fill="currentColor"
                                    >
                                      <path d="M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 11H11V17H9V11ZM13 11H15V17H13V11ZM9 4V6H15V4H9Z"></path>
                                    </svg>{" "}
                                    {t("Remove Cover")}
                                  </button>
                                ) : (
                                  ""
                                )}
                              </div>
                            </Popover.Body>
                          </Popover>
                        </Overlay>
                      </div>
                    ) : (
                      ""
                    )}
                    {userRole !== "provider" && false && (
                      <button
                        className="session-btn d-flex gap-2 align-items-center mt-4"
                        onClick={() => setIsOpen(true)}
                      >
                        {t("Buy Credits")}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_3328_67950)">
                            <path
                              d="M4.97643 19.998C4.7573 19.998 4.53971 19.9296 4.354 19.7953C4.00808 19.5446 3.84648 19.1137 3.94063 18.6979L5.22729 13.0302L0.863771 9.20349C0.543023 8.92349 0.420491 8.48005 0.552178 8.07431C0.683865 7.66933 1.04215 7.38261 1.46636 7.3434L7.23982 6.81925L9.52244 1.47746C9.69075 1.085 10.0741 0.831543 10.4999 0.831543C10.9258 0.831543 11.3091 1.085 11.4774 1.47655L13.7601 6.81925L19.5326 7.3434C19.9577 7.3817 20.316 7.66933 20.4477 8.07431C20.5794 8.47929 20.4576 8.92349 20.1369 9.20349L15.7734 13.0294L17.06 18.697C17.1543 19.1137 16.9926 19.5446 16.6468 19.7946C16.3018 20.0445 15.8417 20.0638 15.4784 19.8454L10.4999 16.8703L5.52148 19.8471C5.35317 19.947 5.16564 19.998 4.97643 19.998ZM10.4999 15.5887C10.6892 15.5887 10.8765 15.6395 11.045 15.7395L15.7435 18.5496L14.5291 13.2002C14.4425 12.8195 14.5717 12.422 14.8659 12.1644L18.986 8.55101L13.535 8.056C13.1425 8.02014 12.805 7.7734 12.6516 7.41176L10.4999 2.37074L8.34565 7.41252C8.19398 7.77172 7.85644 8.01846 7.46489 8.05432L2.01309 8.54933L6.13307 12.1627C6.42818 12.421 6.55728 12.8178 6.46984 13.1994L5.25643 18.5487L9.95489 15.7395C10.1232 15.6395 10.3107 15.5887 10.4999 15.5887ZM7.19572 6.92255C7.19572 6.92255 7.19572 6.92347 7.19481 6.92423L7.19572 6.92255ZM13.8025 6.92011L13.8034 6.92179C13.8034 6.92087 13.8034 6.92087 13.8025 6.92011Z"
                              fill="#ffffff"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_3328_67950">
                              <rect
                                width="20"
                                height="20"
                                fill="white"
                                transform="translate(0.5 0.402344)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </button>
                    )}

                    <></>
                  </div>
                </div>
              </div>
              {userRole !== "provider" && (
                <div className="d-flex gap-3 align-items-center justify-content-between profile-details-inco mt-4">
                  <div className="name-box">
                    {isOther === "0" ? (
                      <h1 className="profile-title">{t("My Profile")}</h1>
                    ) : (
                      ""
                    )}
                    <h4 className="profile-titlename">{name}</h4>
                    <p>{role}</p>
                    {/* <h1 className="profile-title"> Welcome Back!</h1>
                      <h4 className="profile-titlename"> {coachData?.firstname}{" "}{coachData?.lastname} </h4> */}
                    {/* <div className="profilde mb-2"></div> */}
                    {(!_.isEmpty(userDetailState?.office_city) ||
                      !_.isEmpty(userDetailState?.office_province) ||
                      !_.isEmpty(country)) && (
                      <div className="exffpe">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_4490_46898)">
                            <path
                              d="M9.99991 0.5C5.92603 0.5 2.61182 3.81421 2.61182 7.88809C2.61182 9.22925 3.21329 10.6717 3.2385 10.7325C3.43276 11.1936 3.81608 11.9098 4.09248 12.3296L9.1581 20.005C9.3654 20.3196 9.67222 20.5 9.99991 20.5C10.3276 20.5 10.6344 20.3196 10.8417 20.0054L15.9078 12.3296C16.1846 11.9098 16.5675 11.1936 16.7618 10.7325C16.787 10.6721 17.388 9.22968 17.388 7.88809C17.388 3.81421 14.0738 0.5 9.99991 0.5ZM15.9604 10.3953C15.787 10.8086 15.4302 11.4748 15.182 11.8512L10.1159 19.5269C10.016 19.6786 9.98426 19.6786 9.88431 19.5269L4.81825 11.8512C4.5701 11.4748 4.21329 10.8081 4.03989 10.3948C4.0325 10.377 3.481 9.04933 3.481 7.88809C3.481 4.29357 6.40538 1.36919 9.99991 1.36919C13.5944 1.36919 16.5188 4.29357 16.5188 7.88809C16.5188 9.05106 15.966 10.3822 15.9604 10.3953Z"
                              fill="black"
                            />
                            <path
                              d="M9.99972 3.97656C7.84283 3.97656 6.08838 5.73145 6.08838 7.88791C6.08838 10.0444 7.84283 11.7992 9.99972 11.7992C12.1566 11.7992 13.9111 10.0444 13.9111 7.88791C13.9111 5.73145 12.1566 3.97656 9.99972 3.97656ZM9.99972 10.9301C8.32262 10.9301 6.95757 9.56544 6.95757 7.88791C6.95757 6.21037 8.32262 4.84575 9.99972 4.84575C11.6768 4.84575 13.0419 6.21037 13.0419 7.88791C13.0419 9.56544 11.6768 10.9301 9.99972 10.9301Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_4490_46898">
                              <rect
                                width="20"
                                height="20"
                                fill="white"
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        {userDetailState?.office_city}
                        {!_.isEmpty(userDetailState?.office_city) &&
                        !_.isEmpty(userDetailState?.office_city)
                          ? ", "
                          : " "}{" "}
                        {userDetailState?.office_province}
                        {(!_.isEmpty(userDetailState?.office_city) ||
                          !_.isEmpty(userDetailState?.office_province)) &&
                        country
                          ? ", "
                          : " "}{" "}
                        {country}
                      </div>
                    )}
                    <div className="exffpe">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                      >
                        <path
                          d="M16.8292 16.1515H3.17098C2.72703 16.151 2.30141 15.9744 1.98751 15.6605C1.6736 15.3465 1.49705 14.9209 1.49658 14.4769V6.04175C1.49705 5.5978 1.6736 5.17216 1.98751 4.85823C2.30141 4.54429 2.72703 4.3677 3.17098 4.36719H16.8292C17.2732 4.3677 17.6988 4.54429 18.0127 4.85823C18.3266 5.17216 18.5032 5.5978 18.5036 6.04175V14.4769C18.5032 14.9209 18.3266 15.3465 18.0127 15.6605C17.6988 15.9744 17.2732 16.151 16.8292 16.1515ZM3.17098 5.00719C2.89671 5.00748 2.63375 5.11658 2.43982 5.31054C2.24589 5.5045 2.13684 5.76747 2.13658 6.04175V14.4769C2.13684 14.7512 2.24589 15.0142 2.43982 15.2082C2.63375 15.4021 2.89671 15.5112 3.17098 15.5115H16.8292C17.1035 15.5112 17.3665 15.4021 17.5604 15.2082C17.7543 15.0142 17.8634 14.7512 17.8636 14.4769V6.04175C17.8634 5.76747 17.7543 5.5045 17.5604 5.31054C17.3665 5.11658 17.1035 5.00748 16.8292 5.00719H3.17098Z"
                          fill="black"
                        />
                        <path
                          d="M10 12.1431C9.92201 12.1431 9.84667 12.1147 9.78817 12.0631L2.07617 5.25539L2.49969 4.77539L10 11.3968L17.5007 4.77619L17.9242 5.25619L10.2122 12.0639C10.1535 12.1153 10.078 12.1435 10 12.1431Z"
                          fill="black"
                        />
                        <path
                          d="M1.90234 15.1465L7.08319 9.24346L7.56447 9.66586L2.38362 15.5689L1.90234 15.1465Z"
                          fill="black"
                        />
                        <path
                          d="M12.4521 9.66016L12.9334 9.23776L18.1144 15.1409L17.6331 15.5633L12.4521 9.66016Z"
                          fill="black"
                        />
                      </svg>{" "}
                      {userDetailState?.email}
                    </div>
                    {false && (
                      <div className="exffpe">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="21"
                          viewBox="0 0 20 21"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_4490_47022)">
                            <path
                              d="M4.0752 13.7947C6.04785 16.1527 8.42249 18.0093 11.1328 19.323C12.1647 19.8121 13.5447 20.3923 15.0822 20.4917C15.1776 20.4959 15.2687 20.5 15.3641 20.5C16.396 20.5 17.2248 20.1436 17.9003 19.4101C17.9045 19.4059 17.9127 19.3976 17.9169 19.3893C18.1573 19.0993 18.4308 18.8382 18.7167 18.5605C18.9115 18.374 19.1104 18.1792 19.3011 17.9803C20.1838 17.0603 20.1838 15.8916 19.2928 15.0006L16.8021 12.5099C16.3794 12.0707 15.8738 11.8386 15.3433 11.8386C14.8129 11.8386 14.3031 12.0707 13.868 12.5058L12.3844 13.9894C12.2476 13.9107 12.1067 13.8402 11.9741 13.7739C11.8083 13.691 11.655 13.6123 11.5182 13.5253C10.1672 12.6674 8.94051 11.5485 7.7677 10.1104C7.17508 9.36034 6.77723 8.73042 6.49957 8.08807C6.88913 7.73581 7.25382 7.36697 7.60608 7.00642C7.7304 6.87795 7.85887 6.74948 7.98734 6.62101C8.43492 6.17344 8.67528 5.65541 8.67528 5.12909C8.67528 4.60278 8.43906 4.08475 7.98734 3.63717L6.75237 2.4022C6.60732 2.25715 6.47056 2.11625 6.32966 1.9712C6.05614 1.68939 5.77019 1.3993 5.48838 1.13821C5.06153 0.719644 4.56008 0.5 4.02962 0.5C3.5033 0.5 2.9977 0.719644 2.55427 1.14235L1.00434 2.69229C0.440722 3.25591 0.121617 3.9397 0.0553097 4.73125C-0.0234305 5.72172 0.158915 6.77435 0.631356 8.04662C1.35659 10.0151 2.45067 11.8427 4.0752 13.7947ZM1.0665 4.81828C1.11623 4.26709 1.32758 3.80709 1.72543 3.40924L3.26708 1.86759C3.50744 1.63552 3.77267 1.51533 4.02962 1.51533C4.28241 1.51533 4.53935 1.63552 4.77557 1.87588C5.05324 2.13282 5.31432 2.4022 5.59613 2.68815C5.73703 2.8332 5.88208 2.97824 6.02713 3.12743L7.26211 4.36241C7.51905 4.61935 7.65166 4.88044 7.65166 5.13738C7.65166 5.39432 7.51905 5.65541 7.26211 5.91235C7.13364 6.04082 7.00516 6.17344 6.87669 6.30191C6.49128 6.69146 6.13073 7.0603 5.73289 7.41256C5.7246 7.42085 5.72046 7.42499 5.71217 7.43328C5.3682 7.77725 5.42207 8.10464 5.50496 8.35329C5.5091 8.36573 5.51325 8.37402 5.51739 8.38645C5.83649 9.15313 6.27993 9.88251 6.97201 10.7528C8.21528 12.2862 9.52485 13.4755 10.967 14.3914C11.1452 14.5075 11.3359 14.5986 11.5141 14.6898C11.6798 14.7727 11.8332 14.8514 11.9699 14.9385C11.9865 14.9467 11.9989 14.955 12.0155 14.9633C12.1523 15.0338 12.2849 15.0669 12.4175 15.0669C12.7491 15.0669 12.9646 14.8556 13.035 14.7851L14.5849 13.2352C14.8253 12.9948 15.0864 12.8663 15.3433 12.8663C15.6583 12.8663 15.9152 13.0611 16.0769 13.2352L18.5758 15.73C19.0731 16.2273 19.069 16.7661 18.5634 17.2924C18.3893 17.4789 18.207 17.6571 18.0122 17.8436C17.7221 18.1254 17.4196 18.4155 17.1461 18.7429C16.6695 19.2567 16.1017 19.4971 15.3682 19.4971C15.2977 19.4971 15.2231 19.493 15.1527 19.4888C13.7934 19.4018 12.5294 18.8713 11.5804 18.4196C9.00268 17.1722 6.73993 15.4026 4.8626 13.1564C3.31681 11.2957 2.27661 9.56341 1.58867 7.7068C1.16182 6.56714 1.00019 5.65126 1.0665 4.81828Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_4490_47022">
                              <rect
                                width="20"
                                height="20"
                                fill="white"
                                transform="translate(0 0.5)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        (239) 000-0000
                      </div>
                    )}
                  </div>
                  {false && (
                    <div className="credit-box">
                      <svg
                        width="66"
                        height="66"
                        viewBox="0 0 66 66"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="33" cy="33" r="33" fill="#F3F7FF" />
                        <g clip-path="url(#clip0_4490_47793)">
                          <path
                            d="M19.1516 51.0001H46.8771C49.1006 51.0083 50.9092 49.2116 50.9154 46.9881V26.3136C50.9128 24.0815 49.1095 22.27 46.8774 22.2576H45.4605L42.5338 16.1123C42.4566 15.9521 42.3188 15.8286 42.1507 15.7702C41.9826 15.7114 41.7981 15.7219 41.6379 15.7994L37.0234 17.996L35.1315 15.2932C34.9214 14.9866 34.5025 14.9078 34.1952 15.1172L23.9748 22.2576H19.1516C16.9195 22.27 15.1159 24.0815 15.1133 26.3136V46.9881C15.1195 49.2116 16.9281 51.0083 19.1516 51.0001ZM49.5707 42.6799H42.4015C40.9186 42.6799 39.7377 41.4412 39.7377 39.9584V33.3433C39.7331 32.6339 40.0119 31.952 40.5119 31.4484C41.0118 30.9451 41.6921 30.6618 42.4015 30.6618H49.5707V42.6799ZM43.9717 22.2576H31.1506L41.608 17.2859L43.9717 22.2576ZM34.4152 16.605L35.792 18.5676L28.0187 22.2576H26.3211L34.4152 16.605ZM16.458 26.3136C16.4596 24.8238 17.6618 23.6137 19.1516 23.6022H46.8771C48.3672 23.6137 49.5691 24.8238 49.5707 26.3136V29.3171H42.4015C41.3355 29.3175 40.3132 29.7426 39.5611 30.498C38.8093 31.2534 38.3888 32.2773 38.3931 33.3433V39.9584C38.3931 42.1829 40.177 44.0246 42.4015 44.0246H49.5707V46.9881C49.5681 47.6991 49.2828 48.38 48.7776 48.8807C48.272 49.381 47.5885 49.6597 46.8774 49.6554H19.1516C18.4405 49.6597 17.7567 49.381 17.2514 48.8807C16.7462 48.38 16.4606 47.6991 16.458 46.9881V26.3136Z"
                            fill="#415385"
                          />
                          <path
                            d="M41.418 36.651C41.418 37.8811 42.4153 38.8781 43.6451 38.8781C44.8752 38.8781 45.8722 37.8811 45.8722 36.651C45.8722 35.4212 44.8752 34.4238 43.6451 34.4238C42.4156 34.4251 41.4196 35.4215 41.418 36.651ZM43.6451 35.7685C44.1326 35.7685 44.5275 36.1638 44.5275 36.651C44.5275 37.1385 44.1326 37.5334 43.6451 37.5334C43.1579 37.5334 42.7626 37.1385 42.7626 36.651C42.7633 36.1638 43.1579 35.7692 43.6451 35.7685Z"
                            fill="#415385"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_4490_47793">
                            <rect
                              width="36"
                              height="36"
                              fill="white"
                              transform="translate(15 15)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      {
                        <div className="boxdec">
                          <h6>{t("yourCreditPts")}</h6>
                          <div className="pointscedit">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="37"
                              height="37"
                              viewBox="0 0 37 37"
                              fill="none"
                            >
                              <g clip-path="url(#clip0_4490_47801)">
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M9.79297 23.2528C9.79297 20.6289 15.7626 18.5 23.1291 18.5C30.4936 18.5 36.4633 20.629 36.4633 23.2528V27.6212C36.4633 30.2451 30.4936 32.3741 23.1291 32.3741C15.7626 32.3741 9.79297 30.2451 9.79297 27.6212C9.79297 26.1651 9.79297 24.7089 9.79297 23.2528Z"
                                  fill="#FE9923"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M23.1291 18.5C30.4936 18.5 36.4633 20.629 36.4633 23.2528C36.4633 25.8787 30.4936 28.0057 23.1291 28.0057C15.7626 28.0057 9.79297 25.8788 9.79297 23.2528C9.7929 20.6289 15.7626 18.5 23.1291 18.5Z"
                                  fill="#FECD3D"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M23.1306 20.7207C28.9899 20.7207 33.7386 21.8558 33.7386 23.2526C33.7386 24.6515 28.9899 25.7844 23.1306 25.7844C17.2713 25.7844 12.5205 24.6514 12.5205 23.2526C12.5205 21.8558 17.2713 20.7207 23.1306 20.7207Z"
                                  fill="#FEA832"
                                />
                                <path
                                  d="M16.3807 29.7168L17.5198 29.7189V31.9317C17.1293 31.8683 16.7509 31.7967 16.3807 31.719V29.7168ZM32.8602 28.545V30.8703C33.2712 30.7128 33.6516 30.5472 34.0014 30.3733V28.543L32.8602 28.545ZM20.4995 32.2794C20.8759 32.308 21.2563 32.3285 21.6407 32.3428V30.2281L20.4995 30.2302V32.2794ZM12.2598 30.3733C12.6095 30.5472 12.9899 30.7128 13.4009 30.8703V28.543L12.2598 28.545V30.3733ZM24.6204 32.3428C25.0069 32.3285 25.3853 32.306 25.7596 32.2794V30.2302L24.6204 30.2281V32.3428ZM28.7414 31.9317C29.132 31.8683 29.5123 31.7967 29.8805 31.719V29.7189L28.7414 29.7168V31.9317Z"
                                  fill="#C85929"
                                />
                                <path
                                  d="M4.45187 28.5312V29.9465H5.86508V30.9568H4.45187V32.372H3.44162V30.9568H2.02637V29.9465H3.44162V28.5312H4.45187Z"
                                  fill="#FEA832"
                                />
                                <path
                                  d="M30.3043 13.0332V14.4484H31.7195V15.4567H30.3043V16.8718H29.294V15.4567H27.8809V14.4484H29.294V13.0332H30.3043Z"
                                  fill="#FEA832"
                                />
                                <path
                                  d="M5.12863 4.62891V6.04416H6.54184V7.05237H5.12863V8.46762H4.1183V7.05237H2.70312V6.04416H4.1183V4.62891H5.12863Z"
                                  fill="#FEA832"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M0.779625 20.7823C-0.533321 18.5081 3.57328 13.6796 9.95196 9.99838C16.3307 6.31513 22.5642 5.17396 23.8771 7.44603C24.6052 8.70786 25.3332 9.96765 26.0613 11.2274C27.3743 13.5016 23.2677 18.3301 16.889 22.0113C10.5103 25.6946 4.27676 26.8378 2.96381 24.5636C2.23573 23.3039 1.50771 22.0421 0.779625 20.7823Z"
                                  fill="#FE9923"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M9.95196 9.99838C16.3307 6.31513 22.5642 5.17396 23.8771 7.44603C25.1901 9.72022 21.0835 14.5487 14.7048 18.2299C8.32816 21.9132 2.09257 23.0544 0.779625 20.7822C-0.533321 18.5081 3.57328 13.6796 9.95196 9.99838Z"
                                  fill="#FECD3D"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M11.0634 11.9204C16.1373 8.99184 20.8186 7.59909 21.518 8.8098C22.2174 10.0205 18.6692 13.3765 13.5953 16.3072C8.52131 19.2358 3.84208 20.6286 3.14268 19.4178C2.44328 18.2071 5.98942 14.8511 11.0634 11.9204Z"
                                  fill="#FEA832"
                                />
                                <path
                                  d="M14.5283 20.9003L15.5857 22.7307C15.2442 22.9107 14.9046 23.0825 14.5652 23.246L13.5406 21.4709L14.5283 20.9003ZM5.5625 24.1316L6.4767 25.7145C6.86525 25.692 7.27841 25.645 7.71195 25.5754L6.55032 23.561L5.5625 24.1316ZM9.71614 23.0866L10.7182 24.8208C11.0761 24.7042 11.4401 24.5754 11.8103 24.4364L10.7039 22.518L9.71614 23.0866ZM17.1092 19.4094L18.1666 21.2398C18.4918 21.0353 18.8108 20.8267 19.1216 20.6161L18.097 18.8429L17.1092 19.4094ZM24.3899 13.2598L23.402 13.8324L24.5657 15.8448C24.8418 15.5053 25.0893 15.1699 25.304 14.8447L24.3899 13.2598ZM20.4223 16.9062L21.5288 18.8246C21.8356 18.575 22.128 18.3235 22.4082 18.072L21.4081 16.3397L20.4223 16.9062Z"
                                  fill="#C85929"
                                />
                              </g>
                              <defs>
                                <clipPath id="clip0_4490_47801">
                                  <rect
                                    width="36"
                                    height="36"
                                    fill="white"
                                    transform="translate(0.5 0.5)"
                                  />
                                </clipPath>
                              </defs>
                            </svg>
                            {isNaN(userCreditBalance) ? (
                              <ShimmerScreen
                                case="rect"
                                width="2rem"
                                height="2rem"
                              />
                            ) : (
                              userCreditBalance
                            )}
                          </div>
                        </div>
                      }
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="new-profile-page-b2b">
        <section className="user-info-tab">
          <div className="container-pwc">
            <Tab.Container
              id="left-tabs-example"
              defaultActiveKey="personaldetail"
              activeKey={key}
            >
              <Row>
                <Col className="ps-md-0 col-xl-3 col-lg-3 col-md-3 col-12">
                  <Nav
                    variant="pills"
                    className="flex-md-column"
                    onSelect={(k) => {
                      console.log("selectKey: ", k);
                      setKey(k);

                      if (k !== "personaldetail" && isLock) {
                        setConfirmMsgModal(true);
                        return;
                      }

                      if (k === "personaldetail") {
                        navigate(
                          `/profile/edit?section=edit&tab=1&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : authBroker?.payload?.user.user_id
                          }`
                        );
                      } else if (k === "course") {
                        navigate(
                          `/profile/edit?section=edit&tab=2&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "videos") {
                        navigate(
                          `/profile/edit?section=edit&tab=3&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "events") {
                        navigate(
                          `/profile/edit?section=edit&tab=4&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "certifications") {
                        navigate(
                          `/profile/edit?section=edit&tab=5&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "certificates") {
                        navigate(
                          `/profile/edit?section=edit&tab=6&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "badges") {
                        navigate(
                          `/profile/edit?section=edit&tab=7&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "learningpath") {
                        navigate(
                          `/profile/edit?section=edit&tab=8&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "onboarding") {
                        navigate(
                          `/profile/edit?section=edit&tab=9&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      } else if (k === "coachingnotes") {
                        navigate(
                          `/profile/edit?section=edit&tab=10&user_id=${
                            !_.isEmpty(user_id)
                              ? user_id
                              : localStorage.getItem("USER_ID")
                          }`
                        );
                      }
                    }}
                  >
                    <Nav.Item>
                      <Nav.Link eventKey="personaldetail">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.6667 28C17.9303 28 17.3333 27.4031 17.3333 26.6667V16C17.3333 15.2636 17.9303 14.6667 18.6667 14.6667H26.6667C27.4031 14.6667 28 15.2636 28 16V26.6667C28 27.4031 27.4031 28 26.6667 28H18.6667ZM5.33333 17.3333C4.59696 17.3333 4 16.7364 4 16V5.33333C4 4.59696 4.59696 4 5.33333 4H13.3333C14.0697 4 14.6667 4.59696 14.6667 5.33333V16C14.6667 16.7364 14.0697 17.3333 13.3333 17.3333H5.33333ZM12 14.6667V6.66667H6.66667V14.6667H12ZM5.33333 28C4.59696 28 4 27.4031 4 26.6667V21.3333C4 20.5969 4.59696 20 5.33333 20H13.3333C14.0697 20 14.6667 20.5969 14.6667 21.3333V26.6667C14.6667 27.4031 14.0697 28 13.3333 28H5.33333ZM6.66667 25.3333H12V22.6667H6.66667V25.3333ZM20 25.3333H25.3333V17.3333H20V25.3333ZM17.3333 5.33333C17.3333 4.59696 17.9303 4 18.6667 4H26.6667C27.4031 4 28 4.59696 28 5.33333V10.6667C28 11.403 27.4031 12 26.6667 12H18.6667C17.9303 12 17.3333 11.403 17.3333 10.6667V5.33333ZM20 6.66667V9.33333H25.3333V6.66667H20Z"
                            fill="black"
                            fillOpacity="0.6"
                          />
                        </svg>{" "}
                        {t("Personal Details")}
                      </Nav.Link>
                    </Nav.Item>
                    {userRole !== "instructor" &&
                      userRole !== "host" &&
                      userRole !== "provider" && (
                        <>
                          <Nav.Item className={isLock ? "opacity-50" : ""}>
                            <Nav.Link eventKey="course">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M22.6668 20.3269V29.4889C22.6668 29.857 22.3683 30.1557 22.0002 30.1557C21.8794 30.1557 21.7608 30.1227 21.6572 30.0606L16.0002 26.6663L10.3432 30.0606C10.0274 30.2499 9.61794 30.1475 9.4285 29.8319C9.36634 29.7282 9.3335 29.6097 9.3335 29.4889V20.3269C6.89492 18.3721 5.3335 15.3682 5.3335 11.9997C5.3335 6.10863 10.1091 1.33301 16.0002 1.33301C21.8912 1.33301 26.6668 6.10863 26.6668 11.9997C26.6668 15.3682 25.1054 18.3721 22.6668 20.3269ZM12.0002 21.891V25.9565L16.0002 23.5565L20.0002 25.9565V21.891C18.765 22.391 17.4147 22.6663 16.0002 22.6663C14.5856 22.6663 13.2354 22.391 12.0002 21.891ZM16.0002 19.9997C20.4184 19.9997 24.0002 16.4179 24.0002 11.9997C24.0002 7.58139 20.4184 3.99967 16.0002 3.99967C11.5819 3.99967 8.00016 7.58139 8.00016 11.9997C8.00016 16.4179 11.5819 19.9997 16.0002 19.9997Z"
                                  fill="black"
                                />
                              </svg>{" "}
                              {t("Courses")}
                              {isLock && <span class="lock-bar"></span>}
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item className={isLock ? "opacity-50" : ""}>
                            <Nav.Link eventKey="videos">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.33317 25.3333V6.66667H12.7809L15.4476 9.33333H26.6665V25.3333H5.33317ZM27.9998 6.66667H16.5521L13.8854 4H3.99984C3.26346 4 2.6665 4.59696 2.6665 5.33333V26.6667C2.6665 27.4031 3.26346 28 3.99984 28H27.9998C28.7362 28 29.3332 27.4031 29.3332 26.6667V8C29.3332 7.26363 28.7362 6.66667 27.9998 6.66667ZM20.0009 16.8893L13.4957 12.5525C13.4081 12.4941 13.3052 12.4629 13.1998 12.4629C12.9053 12.4629 12.6665 12.7017 12.6665 12.9962V21.6699C12.6665 21.7752 12.6977 21.8781 12.7561 21.9657C12.9194 22.2108 13.2506 22.2771 13.4957 22.1136L20.0009 17.7768C20.0594 17.7377 20.1097 17.6875 20.1488 17.6289C20.3122 17.3839 20.246 17.0527 20.0009 16.8893Z"
                                  fill="black"
                                  fillOpacity="0.6"
                                />
                              </svg>{" "}
                              {t("videos")}
                              {isLock && <span class="lock-bar"></span>}
                            </Nav.Link>
                          </Nav.Item>
                          {false && (
                            <Nav.Item className={isLock ? "opacity-50" : ""}>
                              <Nav.Link eventKey="events">
                                <svg
                                  width="32"
                                  height="32"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M11.9998 1.33301V3.99967H19.9998V1.33301H22.6665V3.99967H27.9998C28.7362 3.99967 29.3332 4.59663 29.3332 5.33301V26.6663C29.3332 27.4027 28.7362 27.9997 27.9998 27.9997H3.99984C3.26346 27.9997 2.6665 27.4027 2.6665 26.6663V5.33301C2.6665 4.59663 3.26346 3.99967 3.99984 3.99967H9.33317V1.33301H11.9998ZM26.6665 14.6663H5.33317V25.333H26.6665V14.6663ZM14.6665 17.333V22.6663H7.99984V17.333H14.6665ZM9.33317 6.66634H5.33317V11.9997H26.6665V6.66634H22.6665V9.33301H19.9998V6.66634H11.9998V9.33301H9.33317V6.66634Z"
                                    fill="black"
                                    fillOpacity="0.6"
                                  />
                                </svg>{" "}
                                {t("Events")}
                                {isLock && <span class="lock-bar"></span>}
                              </Nav.Link>
                            </Nav.Item>
                          )}
                          {false && (
                            <Nav.Item>
                              <Nav.Link eventKey="certifications">
                                <svg
                                  width="32"
                                  height="32"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M10.6003 10.1015H20.8949C20.9457 10.1015 20.988 10.1438 20.988 10.1946C20.988 10.8612 20.988 10.4168 20.988 11.0812C20.988 11.132 20.9457 11.1743 20.8949 11.1743H10.6003C10.5389 11.1743 10.4882 11.1235 10.4882 11.0622C10.4882 10.4083 10.4882 10.8654 10.4882 10.2115C10.4882 10.1523 10.5389 10.1015 10.6003 10.1015ZM7.95735 4.52991H9.60999V3.49304C9.60999 3.22219 9.88085 3 10.2131 3C10.5453 3 10.8161 3.22219 10.8161 3.49304V4.52779H13.4401V3.49304C13.4401 3.22219 13.7109 3 14.041 3C14.3732 3 14.6441 3.22219 14.6441 3.49304V4.52779H17.268V3.49304C17.268 3.22219 17.5389 3 17.8711 3C18.2033 3 18.4742 3.22219 18.4742 3.49304V4.52779H21.0981V3.49304C21.0981 3.22219 21.3689 3 21.7011 3C22.0334 3 22.3042 3.22219 22.3042 3.49304V4.52779H23.5188C24.5959 4.52779 25.4762 5.40807 25.4762 6.48515V27.0426C25.4762 28.1197 24.5959 29 23.5188 29H7.95735C6.88028 29 6 28.1197 6 27.0426V6.48726C6 5.41019 6.88028 4.52991 7.95735 4.52991ZM8.11394 6.19525H9.60999V6.92952C9.60999 7.20037 9.88085 7.42256 10.2131 7.42256C10.5453 7.42256 10.8161 7.20037 10.8161 6.92952V6.19525H13.4401V6.92952C13.4401 7.20037 13.7109 7.42256 14.0431 7.42256C14.3754 7.42256 14.6462 7.20037 14.6462 6.92952V6.19525H17.2701V6.92952C17.2701 7.20037 17.541 7.42256 17.8732 7.42256C18.2054 7.42256 18.4763 7.20037 18.4763 6.92952V6.19525H21.1002V6.92952C21.1002 7.20037 21.371 7.42256 21.7033 7.42256C22.0355 7.42256 22.3063 7.20037 22.3063 6.92952V6.19525H23.3644C23.667 6.19525 23.9167 6.44494 23.9167 6.74754V26.7824C23.9167 27.0829 23.667 27.3347 23.3644 27.3347H8.11394C7.81346 27.3347 7.56165 27.0871 7.56165 26.7824V6.74754C7.56165 6.44494 7.81135 6.19525 8.11394 6.19525ZM10.6003 25.1953H20.8949C20.9457 25.1953 20.988 25.153 20.988 25.1022C20.988 24.4357 20.988 24.88 20.988 24.2156C20.988 24.1648 20.9457 24.1225 20.8949 24.1225H10.6003C10.5389 24.1225 10.4882 24.1733 10.4882 24.2346C10.4882 24.8123 10.4882 24.5076 10.4882 25.0853C10.4882 25.1445 10.5389 25.1953 10.6003 25.1953ZM10.6003 21.6911H20.8949C20.9457 21.6911 20.988 21.6488 20.988 21.598C20.988 20.9315 20.988 21.4774 20.988 20.813C20.988 20.7622 20.9457 20.7199 20.8949 20.7199H10.6003C10.5389 20.7199 10.4882 20.7707 10.4882 20.832C10.4882 21.4859 10.4882 20.9272 10.4882 21.5811C10.4882 21.6404 10.5389 21.6911 10.6003 21.6911ZM10.6003 18.1848H20.8949C20.9457 18.1848 20.988 18.1425 20.988 18.0917C20.988 17.4252 20.988 17.768 20.988 17.1035C20.988 17.0527 20.9457 17.0104 20.8949 17.0104H10.6003C10.5389 17.0104 10.4882 17.0612 10.4882 17.1226C10.4882 17.7764 10.4882 17.4209 10.4882 18.0748C10.4882 18.134 10.5389 18.1848 10.6003 18.1848ZM10.6003 14.6806H20.8949C20.9457 14.6806 20.988 14.6383 20.988 14.5875C20.988 13.921 20.988 14.3653 20.988 13.7009C20.988 13.6501 20.9457 13.6078 20.8949 13.6078H10.6003C10.5389 13.6078 10.4882 13.6586 10.4882 13.7199C10.4882 14.3738 10.4882 13.9167 10.4882 14.5706C10.4882 14.6299 10.5389 14.6806 10.6003 14.6806Z"
                                    fill="black"
                                    fillOpacity="0.6"
                                  />
                                </svg>{" "}
                                {t("certifications")}
                              </Nav.Link>
                            </Nav.Item>
                          )}
                          {false && (
                            <Nav.Item className={isLock ? "opacity-50" : ""}>
                              <Nav.Link eventKey="certificates">
                                <svg
                                  width="32"
                                  height="32"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M16.0002 9.33304C21.8912 9.33304 26.6668 14.1087 26.6668 19.9997C26.6668 25.8908 21.8912 30.6664 16.0002 30.6664C10.1091 30.6664 5.3335 25.8908 5.3335 19.9997C5.3335 14.1087 10.1091 9.33304 16.0002 9.33304ZM16.0002 11.9997C11.5819 11.9997 8.00016 15.5815 8.00016 19.9997C8.00016 24.418 11.5819 27.9997 16.0002 27.9997C20.4184 27.9997 24.0002 24.418 24.0002 19.9997C24.0002 15.5815 20.4184 11.9997 16.0002 11.9997ZM16.0002 13.9997L17.7635 17.5727L21.7066 18.1456L18.8534 20.9268L19.5268 24.8539L16.0002 22.9997L12.4735 24.8539L13.147 20.9268L10.2938 18.1456L14.2368 17.5727L16.0002 13.9997ZM24.0002 2.66637V6.66637L22.1823 8.18312C20.7075 7.40999 19.0702 6.90484 17.335 6.73236L17.3335 2.66504L24.0002 2.66637ZM14.6668 2.66504L14.6664 6.73224C12.9314 6.90456 11.2941 7.40952 9.81938 8.18243L8.00016 6.66637V2.66637L14.6668 2.66504Z"
                                    fill="black"
                                    fillOpacity="0.6"
                                  />
                                </svg>{" "}
                                {t("certificates")}
                                {isLock && <span class="lock-bar"></span>}
                              </Nav.Link>
                            </Nav.Item>
                          )}
                          {false && (
                            <Nav.Item className={isLock ? "opacity-50" : ""}>
                              <Nav.Link eventKey="badges">
                                <svg
                                  width="32"
                                  height="32"
                                  viewBox="0 0 32 32"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M13.3431 2.80535C11.4742 2.20039 9.44275 3.04187 8.54908 4.79107L7.47471 6.89397C7.34706 7.14383 7.14383 7.34705 6.89398 7.4747L4.79107 8.54907C3.04187 9.44274 2.2004 11.4742 2.80535 13.343L3.53263 15.5897C3.61904 15.8566 3.61904 16.1441 3.53263 16.411L2.80535 18.6577C2.2004 20.5265 3.04188 22.558 4.79107 23.4516L6.89398 24.526C7.14383 24.6537 7.34706 24.8569 7.47471 25.1068L8.54908 27.2096C9.44275 28.9588 11.4743 29.8002 13.3431 29.1953L15.5897 28.4681C15.8567 28.3817 16.144 28.3817 16.4109 28.4681L18.6576 29.1953C20.5264 29.8002 22.558 28.9588 23.4516 27.2096L24.526 25.1068C24.6536 24.8569 24.8568 24.6537 25.1067 24.526L27.2096 23.4516C28.9588 22.558 29.8003 20.5265 29.1953 18.6577L28.468 16.411C28.3816 16.1441 28.3816 15.8566 28.468 15.5897L29.1953 13.343C29.8003 11.4742 28.9588 9.44274 27.2096 8.54907L25.1067 7.4747C24.8568 7.34705 24.6536 7.14382 24.526 6.89397L23.4516 4.79107C22.558 3.04187 20.5264 2.20039 18.6576 2.80535L16.4109 3.53262C16.144 3.61903 15.8567 3.61903 15.5897 3.53262L13.3431 2.80535ZM10.9238 6.0043C11.2217 5.42123 11.8988 5.14075 12.5218 5.34239L14.7684 6.06967C15.5692 6.32891 16.4315 6.32891 17.2323 6.06967L19.4789 5.34239C20.1019 5.14075 20.7791 5.42123 21.0769 6.0043L22.1513 8.10721C22.5343 8.85678 23.1439 9.46643 23.8935 9.84939L25.9964 10.9238C26.5795 11.2217 26.86 11.8988 26.6583 12.5218L25.9311 14.7685C25.6717 15.5693 25.6717 16.4314 25.9311 17.2322L26.6583 19.4789C26.86 20.1018 26.5795 20.779 25.9964 21.0769L23.8935 22.1513C23.1439 22.5342 22.5343 23.144 22.1513 23.8934L21.0769 25.9964C20.7791 26.5794 20.1019 26.86 19.4789 26.6582L17.2323 25.931C16.4315 25.6718 15.5692 25.6718 14.7684 25.931L12.5218 26.6582C11.8988 26.86 11.2217 26.5794 10.9238 25.9964L9.8494 23.8934C9.46644 23.144 8.85678 22.5342 8.10722 22.1513L6.00431 21.0769C5.42124 20.779 5.14075 20.1018 5.3424 19.4789L6.06968 17.2322C6.32891 16.4314 6.32891 15.5693 6.06968 14.7685L5.3424 12.5218C5.14075 11.8988 5.42124 11.2217 6.00431 10.9238L8.1072 9.84939C8.85678 9.46643 9.46644 8.85678 9.8494 8.10721L10.9238 6.0043ZM9.01312 15.6769L14.67 21.3337L24.0981 11.9056L22.2125 10.02L14.67 17.5625L10.8987 13.7912L9.01312 15.6769Z"
                                    fill="black"
                                    fillOpacity="0.6"
                                  />
                                </svg>{" "}
                                {t("Badges")}
                                {isLock && <span class="lock-bar"></span>}
                              </Nav.Link>
                            </Nav.Item>
                          )}
                          <Nav.Item className={isLock ? "opacity-50" : ""}>
                            <Nav.Link eventKey="learningpath">
                              <svg
                                width="32"
                                height="32"
                                viewBox="0 0 32 32"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.33333 15.1114L0 12.0003L16 2.66699L32 12.0003V23.3337H29.3333V13.5559L26.6667 15.1114V24.0154L26.3699 24.3822C23.9276 27.4002 20.1891 29.3337 16 29.3337C11.8109 29.3337 8.07239 27.4002 5.63017 24.3822L5.33333 24.0154V15.1114ZM8 16.667V23.0559C9.95628 25.2723 12.8148 26.667 16 26.667C19.1852 26.667 22.0437 25.2723 24 23.0559V16.667L16 21.3337L8 16.667ZM5.29236 12.0003L16 18.2465L26.7076 12.0003L16 5.75421L5.29236 12.0003Z"
                                  fill="black"
                                  fillOpacity="0.6"
                                />
                              </svg>{" "}
                              {t("Action Paths")}
                              {isLock && <span class="lock-bar"></span>}
                            </Nav.Link>
                          </Nav.Item>
                          {!userDetailState?.roles?.includes("customer") &&
                            false && (
                              <Nav.Item className={isLock ? "opacity-50" : ""}>
                                <Nav.Link eventKey="onboarding">
                                  <svg
                                    width="32"
                                    height="32"
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M0.814264 12.2132L1.39156 19.3591C1.46937 20.0971 1.64256 20.5714 1.8534 20.8325C1.94092 20.9312 2.05426 21.0034 2.18066 21.0411C2.30706 21.0788 2.44147 21.0805 2.56874 21.0458H2.63651H5.46778C5.62273 21.0619 5.77925 21.0401 5.92394 20.9824C6.06863 20.9247 6.19719 20.8328 6.29859 20.7145L6.31114 20.6995C6.5196 20.3523 6.62251 19.952 6.60731 19.5474V11.6585C6.59498 11.6239 6.58902 11.5873 6.58974 11.5506C6.58851 11.5406 6.58851 11.5304 6.58974 11.5204C6.57847 11.4152 6.5446 11.3136 6.49045 11.2226C6.4363 11.1316 6.36315 11.0534 6.276 10.9933C5.97621 10.8379 5.63869 10.77 5.30212 10.7976H1.75802C1.61161 10.7895 1.4651 10.8115 1.32744 10.862C1.18978 10.9124 1.06385 10.9905 0.957333 11.0912C0.789164 11.292 0.728924 11.6384 0.811754 12.178V12.2132H0.814264ZM23.369 11.9095C23.3686 11.7895 23.3762 11.6696 23.3916 11.5506L22.0889 10.6746C21.9007 10.5491 21.6948 10.4035 21.4865 10.2579C20.7335 9.73583 19.9805 9.19869 19.1447 8.98033C18.6573 8.85471 18.157 8.78565 17.6538 8.77451C17.1922 8.76263 16.7312 8.81329 16.2833 8.92511C16.0222 8.99131 15.7695 9.08732 15.5303 9.21124C15.3197 9.32228 15.1248 9.46069 14.9505 9.62288L14.057 10.6695C14.03 10.7205 13.9923 10.765 13.9465 10.8001L11.5194 13.6891C11.5507 13.8587 11.6231 14.0182 11.7302 14.1534C11.8478 14.2973 12.0022 14.4066 12.177 14.4697C12.3794 14.5422 12.5955 14.5688 12.8095 14.5475C13.2167 14.5079 13.6029 14.348 13.9189 14.0881L14.5941 13.5234C14.7648 13.3828 14.9078 13.2523 15.0484 13.1243C15.3387 12.8422 15.6565 12.59 15.9972 12.3713C16.7502 11.9195 17.5032 11.9045 18.2562 13.1544L22.0713 20.0494H23.369V11.9095ZM23.6777 10.8076C23.7365 10.7254 23.8038 10.6497 23.8785 10.5817C24.2808 10.2609 24.7883 10.1016 25.3017 10.1349H28.6149C29.3102 10.1349 29.8699 10.2579 30.2665 10.5591C30.7007 10.8954 30.9065 11.405 30.8187 12.1379L30.0857 19.7206C30.0737 20.2905 29.8803 20.8418 29.5335 21.2943C29.3559 21.4935 29.1337 21.6477 28.885 21.7446C28.6364 21.8414 28.3684 21.8781 28.1028 21.8515H25.1235C24.7382 21.8817 24.3559 21.7642 24.0542 21.5227C23.824 21.3309 23.6396 21.0899 23.5146 20.8174H22.483C22.6133 21.1833 22.6203 21.5817 22.5031 21.9519C22.3871 22.2993 22.1715 22.6048 21.8831 22.8304C21.6008 23.0534 21.2666 23.201 20.9117 23.2596C20.5589 23.319 20.1965 23.2791 19.8651 23.1442C19.5337 23.5137 19.1075 23.7853 18.6327 23.9298C18.1996 24.0478 17.7404 24.0268 17.3199 23.8696C16.9599 24.3012 16.4707 24.6057 15.9244 24.738C15.358 24.8433 14.7728 24.7549 14.2628 24.487C14.0875 24.6257 13.8941 24.7397 13.688 24.8259C13.4058 24.9426 13.1021 24.9982 12.7969 24.989C12.1934 25.0007 11.6071 24.7868 11.1529 24.3891C10.777 24.0169 10.4649 23.5852 10.2292 23.1116L8.58267 20.2502H7.3076C7.24996 20.5781 7.12053 20.8892 6.92859 21.1613L6.91102 21.1864C6.73654 21.4017 6.51185 21.5708 6.25669 21.6789C6.00154 21.787 5.72373 21.8308 5.4477 21.8064H2.66412C2.41037 21.8625 2.14608 21.848 1.90001 21.7643C1.65395 21.6807 1.43554 21.5311 1.26857 21.332C0.942273 20.953 0.716374 20.328 0.620995 19.4319V19.3993L0.0436977 12.281C-0.0717617 11.5129 0.0436977 10.9682 0.364976 10.5968C0.538004 10.4101 0.74885 10.2625 0.983442 10.1638C1.21803 10.0652 1.47098 10.0177 1.72539 10.0245H5.2971C5.7842 9.99253 6.27006 10.1033 6.69516 10.3432C6.99118 10.5317 7.2081 10.8218 7.30509 11.159H9.70213C10.2504 10.7661 10.8534 10.4557 11.4917 10.2378C12.16 10.037 12.8637 9.98221 13.555 10.0772L14.3757 9.1008L14.4058 9.06817C14.6312 8.85429 14.8845 8.67191 15.1588 8.52602C15.452 8.37532 15.7609 8.25747 16.08 8.17462C16.5964 8.04813 17.1272 7.9899 17.6588 8.00143C18.2222 8.01411 18.7823 8.09159 19.3279 8.23235C20.2842 8.48335 21.11 9.06315 21.9132 9.62539C22.1065 9.76093 22.2972 9.89396 22.5031 10.032L23.6702 10.8076H23.6777ZM3.95928 17.7301C4.09154 17.7296 4.22097 17.7684 4.33115 17.8416C4.44133 17.9148 4.52729 18.019 4.57814 18.1411C4.62898 18.2632 4.64241 18.3977 4.61673 18.5274C4.59105 18.6572 4.52741 18.7764 4.43389 18.8699C4.34036 18.9634 4.22117 19.0271 4.09142 19.0527C3.96168 19.0784 3.82723 19.065 3.70513 19.0141C3.58302 18.9633 3.47878 18.8773 3.40561 18.7672C3.33243 18.657 3.29363 18.5275 3.29413 18.3953C3.29479 18.2191 3.36508 18.0503 3.48968 17.9257C3.61427 17.8011 3.78307 17.7308 3.95928 17.7301ZM21.6773 20.7823C21.6243 20.7592 21.5771 20.7247 21.5389 20.6814C21.5007 20.638 21.4726 20.5868 21.4564 20.5313L17.586 13.546C17.1568 12.8281 16.7703 12.8081 16.3938 13.0314C16.0963 13.2281 15.8181 13.4525 15.563 13.7016C15.3923 13.8572 15.2216 14.0128 15.081 14.1283L14.3958 14.6931C13.9592 15.0482 13.4274 15.2666 12.8672 15.3206C12.539 15.3499 12.2083 15.3071 11.8984 15.1951C11.5932 15.0821 11.3237 14.8898 11.1178 14.6378C10.8836 14.3422 10.7445 13.9825 10.7187 13.6062C10.7147 13.5501 10.7227 13.4938 10.7422 13.441C10.7617 13.3882 10.7921 13.3401 10.8316 13.3L12.9224 10.8126C12.5135 10.8027 12.1058 10.8595 11.7151 10.9808C11.1206 11.1887 10.5598 11.483 10.051 11.8543C9.98011 11.9113 9.89095 11.9407 9.80002 11.9371H7.3829V19.4671H8.80606C8.8776 19.467 8.94779 19.4866 9.00889 19.5238C9.07 19.561 9.11967 19.6143 9.15244 19.6779L10.9094 22.7275C11.1049 23.126 11.3587 23.4932 11.6624 23.8169C11.9829 24.0881 12.3924 24.2312 12.812 24.2185C13.0097 24.2241 13.2064 24.1882 13.3893 24.113C13.5066 24.0649 13.6172 24.0016 13.7181 23.9248L12.5861 21.8064C12.5455 21.717 12.5404 21.6155 12.5719 21.5225C12.6034 21.4295 12.6691 21.352 12.7557 21.3056C12.8422 21.2593 12.9432 21.2477 13.038 21.2731C13.1329 21.2985 13.2145 21.359 13.2663 21.4424L14.5062 23.7591C14.8586 23.9844 15.2824 24.0697 15.6945 23.9981C16.1065 23.9266 16.4768 23.7034 16.7326 23.3726L14.948 20.5664C14.8921 20.4805 14.8726 20.376 14.8938 20.2757C14.915 20.1755 14.9751 20.0877 15.061 20.0318C15.1478 19.9777 15.2524 19.9598 15.3523 19.9818C15.4522 20.0039 15.5396 20.0641 15.5956 20.1498L17.4756 23.104C17.7739 23.2362 18.108 23.2645 18.4243 23.1843C18.758 23.0791 19.0566 22.8847 19.2878 22.6221L17.5885 19.4143C17.5396 19.3235 17.5288 19.2169 17.5584 19.118C17.5881 19.0192 17.6558 18.9362 17.7466 18.8872C17.8375 18.8383 17.9441 18.8275 18.0429 18.8571C18.1418 18.8868 18.2248 18.9545 18.2737 19.0454L20.0307 22.3636C20.2591 22.4928 20.5258 22.5372 20.7837 22.4891C21.0086 22.4532 21.2204 22.3598 21.3987 22.218C21.5668 22.0902 21.6934 21.9155 21.7626 21.716C21.839 21.4667 21.8184 21.1977 21.7049 20.963C21.6803 20.907 21.67 20.8458 21.6748 20.7848L21.6773 20.7823ZM26.7776 17.7301C26.9095 17.7311 27.0382 17.7712 27.1474 17.8453C27.2566 17.9193 27.3414 18.0241 27.3911 18.1463C27.4407 18.2686 27.4531 18.4028 27.4266 18.532C27.4 18.6613 27.3358 18.7798 27.242 18.8725C27.1482 18.9653 27.029 19.0282 26.8994 19.0533C26.7699 19.0783 26.6358 19.0645 26.5142 19.0134C26.3925 18.9623 26.2887 18.8764 26.2159 18.7664C26.143 18.6564 26.1044 18.5272 26.1049 18.3953C26.1056 18.2191 26.1758 18.0503 26.3004 17.9257C26.425 17.8011 26.5938 17.7308 26.77 17.7301H26.7776Z"
                                      fill="black"
                                      fillOpacity="0.6"
                                    />
                                  </svg>{" "}
                                  {t("onboardings")}
                                  {isLock && <span class="lock-bar"></span>}
                                </Nav.Link>
                              </Nav.Item>
                            )}
                          {!userDetailState?.roles?.includes("customer") &&
                            localStorage.getItem(
                              SessionKeys.SHOW_MENTER_COACH
                            ) !== "false" &&
                            false && (
                              <Nav.Item>
                                <Nav.Link eventKey="coachingnotes">
                                  <svg
                                    width="32"
                                    height="32"
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      fillRule="evenodd"
                                      clipRule="evenodd"
                                      d="M10.6003 10.1015H20.8949C20.9457 10.1015 20.988 10.1438 20.988 10.1946C20.988 10.8612 20.988 10.4168 20.988 11.0812C20.988 11.132 20.9457 11.1743 20.8949 11.1743H10.6003C10.5389 11.1743 10.4882 11.1235 10.4882 11.0622C10.4882 10.4083 10.4882 10.8654 10.4882 10.2115C10.4882 10.1523 10.5389 10.1015 10.6003 10.1015ZM7.95735 4.52991H9.60999V3.49304C9.60999 3.22219 9.88085 3 10.2131 3C10.5453 3 10.8161 3.22219 10.8161 3.49304V4.52779H13.4401V3.49304C13.4401 3.22219 13.7109 3 14.041 3C14.3732 3 14.6441 3.22219 14.6441 3.49304V4.52779H17.268V3.49304C17.268 3.22219 17.5389 3 17.8711 3C18.2033 3 18.4742 3.22219 18.4742 3.49304V4.52779H21.0981V3.49304C21.0981 3.22219 21.3689 3 21.7011 3C22.0334 3 22.3042 3.22219 22.3042 3.49304V4.52779H23.5188C24.5959 4.52779 25.4762 5.40807 25.4762 6.48515V27.0426C25.4762 28.1197 24.5959 29 23.5188 29H7.95735C6.88028 29 6 28.1197 6 27.0426V6.48726C6 5.41019 6.88028 4.52991 7.95735 4.52991ZM8.11394 6.19525H9.60999V6.92952C9.60999 7.20037 9.88085 7.42256 10.2131 7.42256C10.5453 7.42256 10.8161 7.20037 10.8161 6.92952V6.19525H13.4401V6.92952C13.4401 7.20037 13.7109 7.42256 14.0431 7.42256C14.3754 7.42256 14.6462 7.20037 14.6462 6.92952V6.19525H17.2701V6.92952C17.2701 7.20037 17.541 7.42256 17.8732 7.42256C18.2054 7.42256 18.4763 7.20037 18.4763 6.92952V6.19525H21.1002V6.92952C21.1002 7.20037 21.371 7.42256 21.7033 7.42256C22.0355 7.42256 22.3063 7.20037 22.3063 6.92952V6.19525H23.3644C23.667 6.19525 23.9167 6.44494 23.9167 6.74754V26.7824C23.9167 27.0829 23.667 27.3347 23.3644 27.3347H8.11394C7.81346 27.3347 7.56165 27.0871 7.56165 26.7824V6.74754C7.56165 6.44494 7.81135 6.19525 8.11394 6.19525ZM10.6003 25.1953H20.8949C20.9457 25.1953 20.988 25.153 20.988 25.1022C20.988 24.4357 20.988 24.88 20.988 24.2156C20.988 24.1648 20.9457 24.1225 20.8949 24.1225H10.6003C10.5389 24.1225 10.4882 24.1733 10.4882 24.2346C10.4882 24.8123 10.4882 24.5076 10.4882 25.0853C10.4882 25.1445 10.5389 25.1953 10.6003 25.1953ZM10.6003 21.6911H20.8949C20.9457 21.6911 20.988 21.6488 20.988 21.598C20.988 20.9315 20.988 21.4774 20.988 20.813C20.988 20.7622 20.9457 20.7199 20.8949 20.7199H10.6003C10.5389 20.7199 10.4882 20.7707 10.4882 20.832C10.4882 21.4859 10.4882 20.9272 10.4882 21.5811C10.4882 21.6404 10.5389 21.6911 10.6003 21.6911ZM10.6003 18.1848H20.8949C20.9457 18.1848 20.988 18.1425 20.988 18.0917C20.988 17.4252 20.988 17.768 20.988 17.1035C20.988 17.0527 20.9457 17.0104 20.8949 17.0104H10.6003C10.5389 17.0104 10.4882 17.0612 10.4882 17.1226C10.4882 17.7764 10.4882 17.4209 10.4882 18.0748C10.4882 18.134 10.5389 18.1848 10.6003 18.1848ZM10.6003 14.6806H20.8949C20.9457 14.6806 20.988 14.6383 20.988 14.5875C20.988 13.921 20.988 14.3653 20.988 13.7009C20.988 13.6501 20.9457 13.6078 20.8949 13.6078H10.6003C10.5389 13.6078 10.4882 13.6586 10.4882 13.7199C10.4882 14.3738 10.4882 13.9167 10.4882 14.5706C10.4882 14.6299 10.5389 14.6806 10.6003 14.6806Z"
                                      fill="black"
                                      fillOpacity="0.6"
                                    />
                                  </svg>{" "}
                                  {t("Coaching Notes")}
                                </Nav.Link>
                              </Nav.Item>
                            )}
                        </>
                      )}
                  </Nav>
                </Col>
                <Col className="col-xl-9 col-lg-9 col-md-9 col-12">
                  {renderComp()}
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </section>
      </section>
      <ConfirmModal
        confirmModal={confirmModal}
        setConfirmModal={setConfirmModal}
        showModalMsg={showModalMsg}
        isConfirm={isConfirm}
        isRightIcon={true}
        noAction={() => {}}
      />
      <SimplePopup
        confirmModal={showLimitPopup}
        setConfirmModal={setShowLimitPopup}
        showModalMsg={"File size exceeds 1 MB. Please choose a smaller file."}
        isRightIcon={false}
      />
      <BuyCreditPoints
        isOpen={isOpen}
        closeAction={() => setIsOpen(false)}
        isSubscription={false}
        setMainPageLoading={setIsLoading}
      />

      <MsgModal
        confirmModal={confirmMsgModal}
        setConfirmModal={setConfirmMsgModal}
        showModalMsg={t(showModalMsg1)}
        isConfirm={false}
        confirmId={""}
        confirmAction={function name(params) {}}
      />
    </>
  );
};
export default MenuDetailComponent;
